import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

const GA_ID = 'G-C2X5GXCJ88';
const DISABLE_KEY = `ga-disable-${GA_ID}`;

/**
 * GaRouteGuard
 *   - Sets window['ga-disable-<GA_ID>']=true whenever the user is on an /admin route.
 *   - Clears it when the user navigates back to a public page.
 *   - Also fires Mixpanel `page_viewed` on every route change.
 * Mounted once in <App/>, renders nothing.
 */
export default function GaRouteGuard() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const shouldDisable = pathname.startsWith('/admin');
    try {
      window[DISABLE_KEY] = shouldDisable;
    } catch (_) { /* ignore sandboxed environments */ }

    // Categorize the surface for funnel analysis
    let surface = 'marketing';
    if (pathname.startsWith('/manager')) surface = 'manager_app';
    else if (pathname.startsWith('/admin')) surface = 'admin_app';
    else if (pathname.startsWith('/tenant')) surface = 'tenant_onboarding';
    else if (pathname.startsWith('/listings')) surface = 'public_listings';

    trackPageView(pathname, { surface, search: search || undefined });
  }, [pathname, search]);

  return null;
}
